import { Location } from '@angular/common'
import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { CanDeactivate, Router } from '@angular/router'
import { ModalService } from '@app/modal/modal.service'
import { Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'

export interface CanDeactivateComponent {
  canDeactivate: () => boolean | Observable<boolean>
}
@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {
  constructor(private modalService: ModalService, private router: Router, private location: Location) {}
  canDeactivate(component: CanDeactivateComponent): boolean | Observable<boolean> {
    return component.canDeactivate() || this.confirmLeave()
  }
  private confirmLeave(): Observable<boolean> {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      title: 'Deseja sair sem salvar?',
      message: 'As alterações realizadas serão perdidas.',
      primaryOption: 'SIM, CANCELAR',
      secondaryOption: 'NÃO, CONTINUAR AQUI',
    }
    const modalRefComponent = this.modalService.openConfirmModal(dialogConfig)
    return modalRefComponent.afterClosed().pipe(
      switchMap((result: boolean) => {
        if (!result) {
          //Readiciona no historico a url (necessário por causa de um bug no router)
          this.location.go(this.router.url)
        }
        return of(result)
      })
    )
  }
}
